$(document).ready(function ($) {
  $(document).on("click", ".blog_category_filter", function (e) {
    e.preventDefault();
    $(".blog_category_filter").removeClass("active");
    $(this).toggleClass("active");

    let categoryID = $(this).data("id");
    $("#filter-page").val(1);
    let cats = $("#filter-ids").val();

    if (cats === "") {
      var catsFiltered = categoryID;
    } else {
      var catArray = cats.split(",");
      var indexOfCat = catArray.indexOf(categoryID.toString());

      if (indexOfCat !== -1) {
        catArray.splice(indexOfCat, 1);
        var catsFiltered = catArray.toString();
      } else {
        var catsFiltered = categoryID;
      }
    }
    $("#filter-ids").val(catsFiltered);
    $("#blogCategoryFilter").trigger("submit");
  });

  // $(document).on("click", ".changePage", function () {
  //     let currentPage = $("#filter-page").val();
  //     let pageNo = $(this).data("pageno");
  //     $(".pg" + currentPage).removeClass("active");
  //     $(".pg" + currentPage + " .page-link").addClass("changePage");
  //     $(".pg" + pageNo + " .page-link").removeClass("changePage");
  //     $("#filter-page").val(pageNo);
  //     $("#blogCategoryFilter").trigger("submit");
  // });

  /**
   * Blog filter form on submit
   */

  $("#blogCategoryFilter").on("submit", this, function (e) {
    e.preventDefault();
    var section_hero = document.getElementsByClassName("section-hero");

    $.ajax({
      url: truecover_custom_data.ajax_url + "?action=filter_blog_category",
      data: new FormData(this),
      xhrFields: {
        withCredentials: true,
      },
      type: "POST",
      datatype: "HTML",
      processData: false,
      contentType: false,
      beforeSend: function () {
        $(".stk-loader").css("display", "flex");

        $("html, body").animate(
          {
            scrollTop: $(".section-true-story-listing").offset().top - 120,
          },
          500
        );

        $(".blog-listing").html("");
      },
      success: function (response) {
        $(".stk-loader").hide();
        $(".blog-listing").html(response.data.html);
      },
    });
  });
});
